"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { Col } from "react-bootstrap";
import styles from "../NFTImage.module.scss";
import NFTImageBalance from "../NFTImageBalance";
import type { BaseRendererProps } from "../types/renderer-props";
import { withArweaveFallback } from "../utils/arweave-fallback";
function getSrc(nft: BaseRendererProps["nft"], showThumbnail: boolean, showOriginal: boolean): string {
  if (showThumbnail) {
    return nft.thumbnail;
  } else if (nft.scaled && !showOriginal) {
    return nft.scaled;
  } else {
    return nft.image;
  }
}
export default function NFTImageRenderer(props) {
  const $ = _c(25);
  const t0 = !!props.showThumbnail;
  const t1 = !!props.showOriginal;
  let t2;
  if ($[0] !== props.nft || $[1] !== t0 || $[2] !== t1) {
    t2 = getSrc(props.nft, t0, t1);
    $[0] = props.nft;
    $[1] = t0;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const src = t2;
  const shouldLazyLoad = !!props.showThumbnail || props.height === 300;
  const t3 = `mb-2 text-center d-flex align-items-center justify-content-center ${styles.imageWrapper} ${props.heightStyle} ${props.bgStyle}`;
  const t4 = shouldLazyLoad ? "lazy" : "eager";
  const t5 = !shouldLazyLoad;
  const t6 = shouldLazyLoad ? "auto" : "high";
  const t7 = props.imageStyle;
  let t8;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      height: "auto",
      width: "auto",
      maxWidth: "100%",
      maxHeight: "100%"
    };
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  const t9 = props.id ?? `image-${props.nft.id}`;
  const t10 = props.nft.name;
  let t11;
  if ($[5] !== props.nft) {
    t11 = withArweaveFallback(t12 => {
      const {
        currentTarget
      } = t12;
      if (currentTarget.src === props.nft.thumbnail) {
        currentTarget.src = props.nft.scaled ? props.nft.scaled : props.nft.image;
      } else {
        if (currentTarget.src === props.nft.scaled) {
          currentTarget.src = props.nft.image;
        } else {
          if ("metadata" in props.nft) {
            currentTarget.src = props.nft.metadata.image;
          }
        }
      }
    });
    $[5] = props.nft;
    $[6] = t11;
  } else {
    t11 = $[6];
  }
  let t12;
  if ($[7] !== props.imageStyle || $[8] !== props.nft.name || $[9] !== src || $[10] !== t11 || $[11] !== t4 || $[12] !== t5 || $[13] !== t6 || $[14] !== t9) {
    t12 = <Image loading={t4} priority={t5} width="0" height="0" fetchPriority={t6} unoptimized={true} className={t7} style={t8} id={t9} src={src} alt={t10} onError={t11} />;
    $[7] = props.imageStyle;
    $[8] = props.nft.name;
    $[9] = src;
    $[10] = t11;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t9;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== props.height || $[17] !== props.nft.contract || $[18] !== props.nft.id || $[19] !== props.showBalance) {
    t13 = props.showBalance && <NFTImageBalance contract={props.nft.contract} tokenId={props.nft.id} height={props.height} />;
    $[16] = props.height;
    $[17] = props.nft.contract;
    $[18] = props.nft.id;
    $[19] = props.showBalance;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t12 || $[22] !== t13 || $[23] !== t3) {
    t14 = <Col xs={12} className={t3}>{t12}{t13}</Col>;
    $[21] = t12;
    $[22] = t13;
    $[23] = t3;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  return t14;
}